import { css } from '@leafygreen-ui/emotion';

export const containerStyle = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const selectStyle = css`
  min-width: 144px;
  height: 100%;
`;
